<template>
  <div class="home">
    <Intro />
    <!-- <hr>
    <h2>Sample video</h2> -->
    <Chunk :chunkID="homePageChunkID" :needsVideoTitle="true" />
    <h2>All videos</h2>
    <VideosList :videos="videosAll" />
    <div class="center">
      <hr>
      <Subscribe />
      <hr>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Intro from '@/components/Intro'
import Chunk from '@/components/Chunk'
import VideosList from '@/components/VideosList'
import Subscribe from '@/components/Subscribe'
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  components: {
    Intro,
    Chunk,
    VideosList,
    Subscribe
  },
  computed: {
    ...mapGetters([
      // 'chunkByID',
      // 'chunksAll',
      'videosAll'
    ]),
    videos() {
      return this.videosAll()
    },
    homePageChunkID() {
      return this.$store.state.homePageChunkID
    },
    // chunk() {
    //   return this.chunkByID(this.chunksAll[11].id)
    // },
  }
}
</script>
